import React, { Component } from "react";

import { RadialChart, Hint } from "react-vis";

export default class Donut extends Component {
  state = {
    value: false,
  };

  static getDerivedStateFromProps(props) {
    const DATA = props.data.map((series) => {
      return { Percentage: series.percentage, Category: series.category };
    });
    console.log(DATA);
    return {
      DATA,
    };
  }

  render() {
    const { value } = this.state;
    return (
      this.state.DATA && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <RadialChart
            className={"donut-chart-example"}
            innerRadius={80}
            radius={120}
            getAngle={(d) => d.Percentage}
            data={this.state.DATA}
            onValueMouseOver={(v) => {
              this.setState({
                value: {
                  Percentage: v.Percentage,
                  x: v.x,
                  y: v.y,
                  Category: v.Category,
                },
              });
              console.log(v);
            }}
            onSeriesMouseOut={(v) => this.setState({ value: false })}
            width={240}
            height={280}
            padAngle={0.04}
            center={{ x: 0, y: 0 }}
          >
            <div
              style={{
                padding: "0 10px",
                fontSize: "20px",
                position: "absolute",
                top: "106px",
                left: "73px",
                textAlign: "center",
                color: "#777777",
                fontWeight: "400",
              }}
            >
              Spend <br />
              Analysis
            </div>

            {value !== false && (
              <Hint value={value}>
                <div style={{ padding: "0 10px" }} className="label-wrapper">
                  <div className="label-title">{this.state.value.Category}</div>
                  <div className="label-value">
                    {this.state.value.Percentage}%
                  </div>
                </div>
              </Hint>
            )}
          </RadialChart>
        </div>
      )
    );
  }
}
